// lib/coverLetterPdf.ts
// Generates cover letter as a .doc file (HTML-based Word format).
// No external dependencies - Chrome Web Store compliant.

export async function downloadCoverLetterPdf(
  coverLetter: string,
  fileName = "Cover_Letter.doc"
) {
  const htmlContent = `
    <html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
    <head><meta charset="utf-8"><title>Cover Letter</title>
    <style>
      body { font-family: Calibri, sans-serif; font-size: 11pt; line-height: 1.6; margin: 1in; }
      p { margin: 0 0 10pt 0; }
    </style></head>
    <body>${coverLetter.split("\n").map((line: string) => `<p>${line || "&nbsp;"}</p>`).join("")}</body></html>
  `;
  const blob = new Blob([htmlContent], { type: "application/msword" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}